<template>
  <div class="events-page">
    <!-- Top navigation panel -->
    <TopPanel />
    <transition-group name="fade-slide" tag="div" class="event-list">
      <div class="log-wrapper">
        <h1 class="log-heading">User Event Log</h1>

        <div class="scroll-container">
          <q2-optgroup label="User Actions">
            <q2-option
              v-for="(action, index) in typedActions"
              :key="index"
              :value="index"
              class="event-entry"
            >
              <div class="event-line">
                🛠️ <strong>{{ action.action }}</strong>
              </div>
              <div class="event-line">
                👤 <strong>User:</strong> {{ action.user_id }}
              </div>
              <div class="event-line">
                🏦 <strong>FI:</strong> {{ action.fi_number }} &nbsp;&nbsp;🧩
                <strong>Config:</strong> {{ action.config_id }}
              </div>
              <div class="event-line">
                🏗️ <strong>Build:</strong> {{ action.build_id }}
              </div>
              <div class="event-line">
                📝 <strong>Metadata:</strong> {{ action.metadata }}
              </div>
              <div class="event-line">
                🕒 <strong>{{ formatTimestamp(action.timestamp) }}</strong>
              </div>
            </q2-option>
          </q2-optgroup>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script setup lang="ts">
import { onMounted, computed } from "vue";
import { useFiStore } from "../stores/buildStores";
import TopPanel from "../components/topPanel.vue";

const fiStore = useFiStore();
const actions = computed(() => fiStore.actions);

interface UserAction {
  action: string;
  user_id: string;
  build_id: string;
  fi_number: string;
  config_id: string;
  metadata: string;
  timestamp: string;
}

// const typedActions = computed(() => actions.value as UserAction[]) // in order
const typedActions = computed(
  () => [...actions.value].reverse() as UserAction[]
); // reverse order

onMounted(() => {
  fiStore.loadUserActions(); // ✅ correct
});

function formatTimestamp(ts) {
  return new Date(ts).toLocaleString();
}
</script>

<style scoped>
th {
  text-align: left;
}

.events-page {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px; /* vertical spacing between cards */
  box-sizing: border-box;
}

.log-wrapper {
  max-width: 2000px;
  margin: 0 auto;
  padding: 2rem 1.5rem;
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

.log-heading {
  font-size: 1.75rem;
  font-weight: bold;
  color: #1f2937;
  margin-bottom: 1.5rem;
}

.fade-slide-enter-active {
  transition: all 0.8s ease;
}
.fade-slide-enter-from {
  opacity: 0;
  transform: translateY(10px);
}
.fade-slide-enter-to {
  opacity: 1;
  transform: translateY(0);
}

/* Optional: extra spacing or highlight */
/* .event-entry {
  margin-bottom: 6px;
  padding: 6px 10px;
} */

.event-entry {
  margin-bottom: 14px;
  padding: 12px 16px;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.6;
  color: #1f2937;
}
.event-line {
  margin-bottom: 4px;
}

.scroll-container {
  height: 70vh;
  overflow-y: auto;
}
</style>
